import React, { useState, useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Route, Routes, useNavigate } from 'react-router-dom';

import './menu.css'
import toast from 'react-hot-toast';

import Loader from '../init/loader';


import {
  BiMenu, BiGridAlt, BiCartAlt, BiBox, BiGroup, BiArchiveIn,
  BiCog, BiLogOut, BiFile, BiBriefcase, BiIdCard
} from "react-icons/bi";
import { MdRecentActors } from 'react-icons/md';


import { BsCartPlus } from "react-icons/bs";
import { PiDevToLogo } from "react-icons/pi";
import { VscTools } from "react-icons/vsc";

import { DataContext } from '../init/getData';

import Dashboard from '../dashboard/dashboard';
import SettingTab from '../settings/settingTab';
import AccountTab from '../accountTab/accountTab';
import TransactionsTab from '../transactionsTab/transactionTab';
import MembershipTransactionsTab from '../membershipsTab/membershipTab';
import ToolTab from '../toolTab/toolTab';
import DevTab from '../devTab/devTab';
import ReportTab from '../reportTab/reportTab';
import LatestMembershipTransactionsTab from '../latestMembershipTab/latestMembershipTab';

const type = 'electron';

const DashboardLazy = React.lazy(() => import('../dashboard/dashboard'))
const SettingTabLazy = React.lazy(() => import('../settings/settingTab'))

const AccountTabLazy = React.lazy(() => import('../accountTab/accountTab'))
const TransactionsTabLazy = React.lazy(() => import('../transactionsTab/transactionTab'))
const MembershipsTabLazy = React.lazy(() => import('../membershipsTab/membershipTab'))
const ReportTabLazy = React.lazy(() => import('../reportTab/reportTab'))
const LatestMembershipTabLazy = React.lazy(() => import('../latestMembershipTab/latestMembershipTab'))
const ToolTabLazy = React.lazy(() => import('../toolTab/toolTab'))




function Menu(props) {


  const { settingData, userData, setAccess, expireyDate, setLoaderEffect, devData } = useContext(DataContext);


  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const [toggle, setToggle] = useState('sidebar');
  const [tog, setTog] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    setLoaderEffect(false)
  }, []);


  let DashboardComponent, SettingTabComponent, AccountTabComponent, ToolTabComponent,
    TransactionsTabComponent, MembershipTransactionsTabComponent, ReportTabComponent,
    LatestMembershipTabComponent, DevTabComponent;

  if (devData.isWebApp) {
    DashboardComponent = DashboardLazy;
    SettingTabComponent = SettingTabLazy;
    AccountTabComponent = AccountTabLazy;
    TransactionsTabComponent = TransactionsTabLazy;
    MembershipTransactionsTabComponent = MembershipsTabLazy;
    ReportTabComponent = ReportTabLazy;
    LatestMembershipTabComponent = LatestMembershipTabLazy;
    ToolTabComponent = ToolTabLazy;
    DevTabComponent = DevTab;
  } else {
    DashboardComponent = Dashboard;
    SettingTabComponent = SettingTab;
    AccountTabComponent = AccountTab;
    TransactionsTabComponent = TransactionsTab;
    MembershipTransactionsTabComponent = MembershipTransactionsTab;
    ReportTabComponent = ReportTab;
    LatestMembershipTabComponent = LatestMembershipTransactionsTab;
    ToolTabComponent = ToolTab;
    DevTabComponent = DevTab;
  }


  const toggles = () => {
    if (tog == 1) {
      setTog(0);
      setToggle('sidebar open')
    }
    else {
      setTog(1);
      setToggle('sidebar')
    }
  }

  const signOut = () => {
    toast.success('Logged out');
    navigate('/');
    setAccess(false);
  }

  return (
    <div>
      <div className={toggle}>
        <div className="logo-details">
          <i className='bx'></i>
          <div className="logo_name">Riser</div>
          <i className='bx' id="btn" onClick={toggles}><BiMenu /></i>
        </div>
        <ul className="nav-list">


          {userRole.accountTab &&
            <li>
              <NavLink to="accountTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
                <i className='bx'><BiGroup /></i>
                <span className="links_name">Accounts</span>
              </NavLink>
              <span className="tooltip">Accounts</span>
            </li>
          }

          {userRole.transactionsTab &&
            <li>
              <NavLink to="transactionsTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
                <i className='bx'><BiBriefcase /></i>
                <span className="links_name">Transactions</span>
              </NavLink>
              <span className="tooltip">Transactions</span>
            </li>
          }

        {userRole.membershipTab &&
          <li>
            <NavLink to="membershipTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
              <i className='bx'><BiIdCard /></i>
              <span className="links_name">Memberships</span>
            </NavLink>
            <span className="tooltip">Memberships</span>
          </li>
            }

            {userRole.reportTab &&

          <li>
            <NavLink to="reportTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
              <i className='bx'><BiFile /></i>
              <span className="links_name">Report</span>
            </NavLink>
            <span className="tooltip">Report</span>
          </li>
          }

          {userRole.latestMembershipTab &&
          <li>
            <NavLink to="latestMembershipTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
              <i className='bx'><MdRecentActors /></i>
              <span className="links_name">Latest Memberships</span>
            </NavLink>
            <span className="tooltip">Latest Memberships</span>
          </li>
          }





          {userRole.settingTab &&
            <li>
              <NavLink to="settingTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
                <i className='bx' ><BiCog /></i>
                <span className="links_name">Settings</span>
              </NavLink>
              <span className="tooltip">Settings</span>
            </li>
          }

      {userId == 777 &&
            <li>
              <NavLink to="devTab" className={({ isActive }) => (isActive ? "active-style" : 'none')}>
                <i className='bx' ><PiDevToLogo /></i>
                <span className="links_name">Dev </span>
              </NavLink>
              <span className="tooltip">Dev </span>
            </li>
          }

          <li className="profile">
            <div className="profile-details">
              <div className="name_job">
                <div className="name">User: {userName}</div>
                <div className="job">Role: {userRole.name}</div>

              </div>
            </div>
            <button onClick={signOut}>
              <i className='bx' id="log_out" ><BiLogOut /></i>
            </button>
          </li>
        </ul>
      </div>

      <section className="home-section">


        <Routes>
          <Route path='dashboard' element={<React.Suspense fallback={<Loader />}> <DashboardComponent /> </React.Suspense>} />
          <Route path='accountTab/*' element={<React.Suspense fallback={<Loader />}> <AccountTabComponent /> </React.Suspense>} />
          <Route path='transactionsTab/*' element={<React.Suspense fallback={<Loader />}> <TransactionsTabComponent /> </React.Suspense>} />
          <Route path='membershipTab/*' element={<React.Suspense fallback={<Loader />}> <MembershipTransactionsTabComponent /> </React.Suspense>} />
          <Route path='reportTab/*' element={<React.Suspense fallback={<Loader />}> <ReportTabComponent /> </React.Suspense>} />
          <Route path='latestMembershipTab/*' element={<React.Suspense fallback={<Loader />}> <LatestMembershipTabComponent /> </React.Suspense>} />
          <Route path='toolTab/*' element={<React.Suspense fallback={<Loader />}> <ToolTabComponent /> </React.Suspense>} />
          <Route path='settingTab/*' element={<React.Suspense fallback={<Loader />}> <SettingTabComponent /> </React.Suspense>} />
          <Route path='devTab/*' element={<React.Suspense fallback={<Loader />}> <DevTabComponent /> </React.Suspense>} />

        </Routes>

      </section>

    </div>

  );
}


export default Menu;